import { render, staticRenderFns } from "./EditAfnParams.vue?vue&type=template&id=fc3bcbbc&"
import script from "./EditAfnParams.vue?vue&type=script&lang=js&"
export * from "./EditAfnParams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports